import { IUsersFilterAndSortParams } from '../../../../types/type';

export const initialFilters: IUsersFilterAndSortParams = {
  userLogin: '',
  displayName: '',
  sorting: {
    sortBy: 'userLogin',
    sortDirection: 'ASC',
  },
  paging: { page: 1, size: 50 },
};
